import React, { memo } from 'react'

import { Grid } from '@material-ui/core'
import { Controller } from 'react-hook-form'
import * as Style from './styles'
import RegisterInput from 'components/RegisterInput'
import { Box } from '@mui/material'

function EmailFieldConfig({ t, errors, control, }) {
    return (
        <Style.Container container item xs={12} spacing={2}>
            <Grid item xs={12}>
                <Style.CustomTitle>
                    <Box component="b" textTransform="uppercase">{t('INFORME SEU E-MAIL')}</Box>
                </Style.CustomTitle>
            </Grid>
            <Grid item container xs={12} md={12}>
                <Controller
                    as={
                        <RegisterInput
                            label="E-mail"
                            xs={12}
                            inputProps={{
                                autoComplete: 'new-password',
                            }}
                            error={!!errors?.email}
                            helperText={t(errors?.email?.message)}
                        />
                    }
                    name="email"
                    control={control}
                    id="email"
                />
            </Grid>
        </Style.Container>
    )
}

export default memo(EmailFieldConfig)

